'use strict';

// Not just the header but also the live chat overlay and CMS bar

var Classnames = require('classnames');
var React = require('react');
var ReactDOM = require('react-dom');
var Reflux = require('reflux');

import PropTypes from 'prop-types';
import isNode from "../is-node"
import css from "../css"
import search from "../../../server/public/static/images/header/search-desktop.png"

if (css) {
    var WebFont = require('webfontloader');
    var requestAnimationFrame = require('requestanimationframe');
    require('./header.scss');
}

var Constants = require('../constants');
var Forms = require('../forms');
var Global = require('../global');
var Overlay = require('./overlay.jsx');
var CMSBar = require('./cms-bar.jsx');
var Store = require('../store').Store;

var ResponsiveMixin = Global.ResponsiveMixin;
var DeviceImage = Global.DeviceImage;

var EXPANDED_WIDTH = 80;
var TAGLINE = 'MODERN OFFICE FURNITURE';

const phone = '888-871-5777'
const link = {
    blog: [
        '/office-furniture-blog',
        'Blog'
    ],
    budget: [
        '/budget-your-office',
        'Budget Your Office Tool'
    ],
    contact: [
        '/office-furniture-dealer-los-angeles',
        'Contact Us'
    ],
    design: [
        '/modern-office-design',
        'Design Your Office Tool'
    ],
    phone: [
        'tel:'+phone.replace(/[^\d]/g,''),
        phone
    ],
}
const menu = {
    mobile: ['contact','phone','blog','budget','design'],
    desktop: ['budget','design','blog','contact','phone']
}

var Logo = React.createClass({
    mixins: [ ResponsiveMixin ],

    getInitialState: function() {
        return {
            retryCount: 0,
            retryDebounce: 0,
        };
    },
    componentDidMount: function() {
        if (!isNode) {
            var node = ReactDOM.findDOMNode(this.refs.tagline);
            var _this = this;

            WebFont.load({
                custom: {
                    families: [ 'Avenir Next Cyr W00 Regular' ],
                },
                active: this._adjustTaglineToFit,
            });
        }
    },
    _adjustTaglineToFit: function() {
        var node = ReactDOM.findDOMNode(this.refs.tagline);

        // Width of 'STRONG PROJECT' part of logo image
        var targetWidth = this.state.viewportLayout == 'desktop' ? 204 : 158;

        // Adjust tracking to fit logo to width of text in logo image
        var letterSpacing = (targetWidth - node.offsetWidth) / TAGLINE.length;

        // #289 Broken on mobile Safari. Retry (but not too often or for too long - don't choke the browser)
        if (letterSpacing < -1 && this.state.retryCount < 10) {
            this.setState({
                taglineLetterSpacing: 0,
                retryCount: this.state.retryCount + 1,
                retryDebounce: this.state.retryDebounce + 100,  // wait 100 ms longer between each retry
            }, () => {
                setTimeout(this._adjustTaglineToFit, this.state.retryDebounce);
            });
            return;
        }

        this.setState({
            taglineLetterSpacing: letterSpacing,
        });
    },
    render: function() {
        var taglineStyle = {
            letterSpacing: this.state.taglineLetterSpacing,
        };
        return (
            <a href='/' className='hd-logo' id='hd-home'>
                <div>
                    <DeviceImage src='header/strongproject-logo.png' width="267" height="86" alt={Payload.header.text['header.alt.logo']} />
                </div>
                <p className='hd-tagline' style={taglineStyle} ref='tagline'>
                    {TAGLINE}
                </p>
            </a>
        );
    },
});

var Search = React.createClass({
    mixins: [ ResponsiveMixin ],

    getInitialState: function() {
        return {
            width: 0,
            targetWidth: 0,
            hasFocus: false,
        };
    },
    componentDidUpdate: function() {
        if (this.state.width < this.state.targetWidth) {
            this.state.width++;
            requestAnimationFrame(this.tick);
        }
        if (this.state.width > this.state.targetWidth) {
            this.state.width--;
            requestAnimationFrame(this.tick);
        }
    },
    tick: function() {
        if (this.state.width == EXPANDED_WIDTH && !this.state.hasFocus) {
            ReactDOM.findDOMNode(this.refs.input).focus();
        }
        if (this.state.width != this.state.targetWidth) {
            requestAnimationFrame(this.tick);
        }
        this.forceUpdate();
    },
    click: function(event) {
        if (this.refs.input) {
            var input = ReactDOM.findDOMNode(this.refs.input);
            if (input.value.length) {
                return;
            }
        }
        event.preventDefault();
        
        if (this.state.viewportLayout == 'desktop') {
            if (this.state.targetWidth == 0) {
                this.setState({
                    targetWidth: EXPANDED_WIDTH
                });
            } else {
                // TODO ??? if (this.refs.input);
                this.setState({
                    targetWidth: 0
                });
            }
        }
    },
    render: function() {
        var searchClasses = Classnames({
            'hd-search': this.state.viewportLayout == 'desktop',
            'hd-search-mobile': this.state.viewportLayout != 'desktop',
        });
        var searchStyle = {
            paddingLeft: (this.state.width ? '1em' : 0),
        };

        var inputStyle = {};
        if (this.state.viewportLayout == 'desktop') {
            inputStyle.width = this.state.width;
        };

        // var image = this.state.viewportLayout == 'desktop'
        //     ? Constants.static + 'images/header/search-desktop.png'
        //     : Constants.static + 'images/header/search-mobile.png';

        return isNode ? null : (
            <div className={searchClasses} style={searchStyle} onMouseOver={this.hover}>
                <form action='/search' method='POST'>
                    {this.state.width || this.state.viewportLayout != 'desktop' ?
                        <input style       = {inputStyle}
                               ref         = 'input'
                               type        = 'text'
                               name        = 'id'
                               maxLength   = '10'
                               placeholder = '  SEARCH' />
                    : null}
                    
                    <input ref     = 'image'
                           type    = 'image'
                           src     = {search}
                           alt     = {Payload.header.text['header.alt.search']}
                           onClick = {this.click} />
                </form>
            </div>
        );
    },
});

var PrimaryTab = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        var classes = Classnames({
            'hd-tab-selected': this.props.selected,
            'hd-tab-content': true,
        });
        if (this.state.viewportLayout == 'desktop') {
            return (
                // ID SET HERE - id={`hd-${this.props.tab}`}
                <a className='hd-tab' href={this.props.href} >
                    <div className={classes}>
                        <span dangerouslySetInnerHTML={{ __html: Payload.header.text[this.props.siteTextName] }} />
                    </div>
                </a>
            );
        } else {
            return (
                <h4>
                    <a href={this.props.href} className={classes}>
                        {Payload.header.text[this.props.siteTextName]}
                    </a>
                </h4>
            );
        }
    },
});

var Project = React.createClass({
    mixins: [ Reflux.connect(Store, 'store') ],

    componentDidMount: function() {
        this.setState({
            mounted: true,  // prevent server/browser mismatch - omit for first render
        });
    },
    render: function() {
        var count = this.state.store.items.length;
        var showCount = this.state.mounted && count;
        var classes = Classnames({
            'hd-tab-selected': this.props.selected,
            'hd-tab-content': true,
            'hd-tab-content-count': showCount,
        });

        // Was a Google Content Experiment "Empty cart vs Specs tab":
        //
        // "If user has zero items in their wishlist and clicks the "request a quote",
        // are they more likely to eventually fill out of form if they're first landed
        // on the empty wishlist page, or on the project specs page." - Johnson

        let url;
        // Send directly to Specs page if user does not have items in cart
        if (count) {
            url = '/your-project';
        } else {
            url = '/your-project/specs';
        }

        return (
            <a className='hd-tab' href={url} id='hd-project'>
                <div className={classes}>
                    <span dangerouslySetInnerHTML={{ __html: Payload.header.text['header.project'] }} />
                    {showCount ?
                        <span className="shopping-cart">
                            {count}
                        </span>
                    : null}
                </div>
            </a>
        );
    }
});

const LandingTier = React.createClass({
    propTypes: {
        type: React.PropTypes.oneOf([ 'full', 'standard', 'hidden' ]).isRequired,
        title: React.PropTypes.bool
    },

    render: function() {
        var strip = null;

        var button = <Forms.Button type      = 'next'
                                   label     = {Payload.header.text['header.landing.button']}
                                   link      = '/full-service-overview'
                                   external  = {true}
                                   theme     = 'dark'/>;

        switch (this.props.type) {
            case 'standard':
            {
                strip = (
                    <div className='hd-landing-standard'>
                        {this.props.title ?
                            <h1 className='hd-landing-title'>
                                Modern Office Furniture for Commercial Spaces
                            </h1>
                            :
                            <p className='hd-landing-title'>
                                Modern Office Furniture for Commercial Spaces
                            </p>
                        }
                        {button}
                    </div>
                );
                break;
            }
            case 'full':
            {
                strip = (
                    <div className='hd-landing-full'>
                        {this.props.title ?
                            <h1 className='hd-landing-title'>
                                Modern Office Furniture for Commercial Spaces
                            </h1>
                            :
                            <p className='hd-landing-title'>
                                Modern Office Furniture for Commercial Spaces
                            </p>
                        }
                        <div className='hd-landing-caption'>
                            {Payload.header.text['header.landing.caption']}
                        </div>
                        {button}
                    </div>
                );
                break;
            }
            case 'hidden':
                return null;
        }
        return (
            <div className='hd-landing'>
                {strip}
            </div>
        );
    }
});

var DesktopHeader = React.createClass({
    mixins: [ Reflux.connect(Store, 'store') ],

    propTypes: {
        tab: React.PropTypes.oneOf([ 'collection', 'company', 'project', 'designtool', 'fulloffice' ]),
        landing: React.PropTypes.oneOf([ 'full', 'standard', 'hidden' ]).isRequired,
        title: PropTypes.bool
    },
    render: function() {
        var tier1classes = Classnames({
            'hd-tier1': true,
            'hd-tier1-push': this.state.store.items.length,
        });
        return (
            <div>
                <div className={tier1classes}>
                    <div className='hd-tabs1'>
                        {menu.desktop.map((id,i) =>
                            <a href={link[id][0]} id={'hd-'+id} key={i}>{link[id][1]}</a>
                        )}
                        <Search desktop={true} />
                    </div>
                </div>

                <div className='hd-tier2'>
                    <Logo />
                    <div className='hd-tabs2'>
                        <PrimaryTab selected={this.props.tab == 'collection'} href='/office-furniture-los-angeles' siteTextName='header.collection' tab={this.props.tab} />
                        <PrimaryTab selected={this.props.tab == 'company'}    href='/modern-office-furniture'      siteTextName='header.thecompany' tab={this.props.tab} /> 
                        <Project selected={this.props.tab == 'project'} />
                    </div>
                </div>

                <LandingTier type={this.props.landing} title={this.props.title} />
            </div>
        );
    }
});

var MobileHeader = React.createClass({
    propTypes: {
        tab: React.PropTypes.oneOf([ 'collection', 'company', 'project', 'designtool', 'fulloffice' ]),
    },
    getInitialState: function() {
        return {
            open: false
        };
    },
    click: function() {
        this.setState({
            open: !this.state.open
        });
    },
    render: function() {
        return (
            <div className='hd-mobile'>
                <div className='hd-menubar'>
                    <div className='hd-menubar-logo'>
                        <Logo />
                    </div>
                    <div className='hd-menubar-buttons'>
                        <button className='hd-menubar-menu' onClick={this.click}>
                            {!this.state.open ?
                                <DeviceImage src='header/menu.png' className='hd-menubar-open' width='21' height='17' alt='Menu' />
                            : null}
                            {this.state.open ?
                                <DeviceImage src='global/close/close-grey2.png'  className='hd-menubar-close' width='21' height='17' alt='Close' />
                            : null}
                        </button>
                    </div>
                </div>

                {this.state.open ?
                    <div className='hd-menu'>
                        <Search desktop={false} />
                        {menu.mobile.map((id,i) =>
                            <h4 key={i}>
                                <a href={link[id][0]}>{link[id][1]}</a>
                            </h4>
                        )}
                    </div>
                :
                    <div className='hd-tier2'>
                        <PrimaryTab selected={this.props.tab == 'collection'} href='/office-furniture-los-angeles' siteTextName='header.collection.mobile' tab={this.props.tab} />
                        <PrimaryTab selected={this.props.tab == 'company'}    href='/the-company'                  siteTextName='header.thecompany.mobile' tab={this.props.tab} />
                        <PrimaryTab selected={this.props.tab == 'project'}    href='/your-project'                 siteTextName='header.project.mobile' tab={this.props.tab} />
                    </div>
                }
            </div>
        );
    }
});

var BusinessSchema = (props) => {
    var jsonLD = {
        "@context" : "http://schema.org",
        "@type" : "LocalBusiness",
        "name" : "STRONGPROJECT INC",
        "image" : "https://strongproject.com/static/images/header/strongproject-logo.png",
        "telephone" : Payload.header.text['header.phone.domestic.human-readable'],
        "address" : "123 Richmond St, El Segundo, CA 90245, USA"
    };
    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />
    );
};


var Header = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        tab: React.PropTypes.oneOf([ 'collection', 'company', 'project', 'designtool', 'fulloffice' ]),
        landing: React.PropTypes.oneOf([ 'full', 'standard', 'hidden' ]).isRequired,
        title: PropTypes.bool
    },

    defaultProps: {
        title: false 
    },

    render: function() {
        return (
            <header id='header'>
                <BusinessSchema />
                {this.state.viewportLayout == 'desktop' ?
                    <DesktopHeader tab={this.props.tab} landing={this.props.landing} title={this.props.title} />
                :
                    <MobileHeader tab={this.props.tab} />
                }
                <Overlay />
                {Payload.release.dev &&
                    <CMSBar />
                }
            </header>
        );
    }
});

module.exports = Header;
 



// WEBPACK FOOTER //
// ./src/components/header.jsx